/**
 * The enum that describes Smart Link action types
 */
export let SmartLinkActionType = /*#__PURE__*/function (SmartLinkActionType) {
  SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
  SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
  SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
  SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
  return SmartLinkActionType;
}({});

/**
 * Default type for an invoke request. Parametrized with the type of payload
 */

/**
 * Captures information about an action
 */

/**
 * payload needed by {@link SmartLinkActionType.StatusUpdateAction} action type
 */

/**
 * Default type for an Action Response
 */

/**
 * Type that signifies an error response from the product
 */

/**
 * Payload from GetStatusTransitions action that contains a list of available statuses
 */

export class InvokeError extends Error {
  constructor(message, errorCode) {
    super(message);
    this.errorCode = errorCode;
  }
}